import authActions from "../actions";
import { useDispatch, useSelector } from "react-redux";
import { 
  IToken,
  LoginNotMadeError
} from "../types/auth";
import { RootState } from "@/store";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { decodeJwt } from "jose";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { 
  loginRequest, 
  loginSuccess,
  logoutRequest,
  logoutSuccess
} from "../actions";
import { default as tokenService } from "../services/token";
import { AxiosError } from "axios";
import { defineToken, undefineToken } from "../utils/token";
import useOpenId from "./useOpenId";
import { useLocation, useNavigate } from "react-router-dom";

const useAuth = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector((store: RootState) => store.auth);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { logoutOpenId } = useOpenId();

  const [token, setToken] = useState<string>();
  const [tokenVals, setTokenVals] = useState<IToken>();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const cookieAuthToken = Cookies.get("token");
      if (cookieAuthToken) {
        setToken(cookieAuthToken);
        setTokenVals(decodeJwt<IToken>(cookieAuthToken));
      }
    } else {
      setToken(undefined);
      setTokenVals(undefined);
    }
  }, [auth.isAuthenticated]);

  const logout = () => {
    dispatch(logoutRequest());
    undefineToken();
    if (Settings.features?.oidc) {

      const openIdToken = Cookies.get('openid_token');
      if (openIdToken) {
        Cookies.remove('openid_token');
        logoutOpenId(openIdToken); // canvi de pagina
      } else {

        // Pel cas que fan inici de sessió amb /acces
        navigate(0);
      }
    }
    dispatch(logoutSuccess());
  };

  const loginRefresh = (token: string) => {
    // Fer time out
    dispatch(loginRequest("refresh"));
    tokenService.validateToken({token})
    .then(({token_is_valid}) => {
      if (token_is_valid) {
        defineToken(token);
        dispatch(loginSuccess());
        if (pathname == t("common:url.login")) {
          navigate("/");
        }
      }
    })
    .catch((err: AxiosError) => {
      // Token probably not valid or has expired so we remove it
      undefineToken();
      dispatch(authActions.loginNotMade());
    });
  }

  const loginNotMade = (err?: LoginNotMadeError) => {
    dispatch(authActions.loginNotMade(err));
  }

  const getErrorMessage = () => {
    if(auth.statusType === "error") {
      switch (auth.type) {
        case "Credentials":
          if (auth.statusCode === 401)
            return t('common:text.login_view_session_expired');
          if (auth.statusCode === 403)
            return t('common:text.login_view_message_error_login');
          break;
        case "Token":
          if (auth.statusCode === 419)
            return t('common:text.errorTokenExpired');
          if (auth.statusCode === 401)
            return t('common:text.login_view_token_invalid');
          break;
        case "ClientID":
          break;
        case "OpenIDSubmit":
          break;
      }

      if (auth.statusCode === 500)
        return t('common:text.errorInternError');

      if (auth.statusCode === 502)
        return t('common:text.errorInternError');

      return t('common:text.login_view_message_error_login');
    }
  }

  return {
    token,
    tokenVals,
    loginRefresh,
    logout,
    loginNotMade,
    getErrorMessage
  };
};

export default useAuth;